import Styled, { css } from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { MaxWidthContainer } from '../../Layout';
import { cssDeclaration } from '../../_ThemeTwo_';
import { HeaderPadding } from '../HeaderInnerContainer';

 // Uses different small padding due to inner components
export const HeaderSubNavInnerContainer = Styled(MaxWidthContainer)`
  flex-direction: column;
  padding: 0;

  ${({ theme }) =>
    css`
      ${media[theme.header.subNavBreakPoint]`
      padding: ${HeaderPadding.Medium};
      flex-direction: row-reverse;
    `}
  `}

  ${media.xlarge`
    padding: ${HeaderPadding.XLarge};
  `}

  ${({ theme }) => theme.header.headerSubNavInnerContainer && css`
    ${theme.header.headerSubNavInnerContainer.padding &&
      cssDeclaration(theme.themeTwo, 'padding', theme.header.headerSubNavInnerContainer.padding)};
  `}
`;

HeaderSubNavInnerContainer.displayName = 'HeaderSubNavInnerContainer';
